import React from 'react';
var css = {
  "tabTitle": "rui-ouaiH",
  "smallTitle": "rui-Q13HY",
  "tabLabel": "rui-7CIJX",
  "roundedBorder": "rui-7OGKR",
  "activeLabel": "rui-q7otw",
  "progessBarAnimation": "rui-oB0Ko",
  "progressAnimation": "rui-MeJNI",
  "disabledLabel": "rui-TgcsP"
};
import TabTitle from "./TabTitle";
function handleTabClick(_ref) {
  var disabled = _ref.disabled,
    changeTab = _ref.changeTab,
    tabID = _ref.tabID;
  if (!disabled) {
    changeTab(tabID);
  }
}
var TabLabel = function TabLabel(_ref2) {
  var tabID = _ref2.tabID,
    _ref2$title = _ref2.title,
    title = _ref2$title === void 0 ? '' : _ref2$title,
    _ref2$subTitle = _ref2.subTitle,
    subTitle = _ref2$subTitle === void 0 ? '' : _ref2$subTitle,
    disabled = _ref2.disabled,
    children = _ref2.children,
    activeTab = _ref2.activeTab,
    changeTab = _ref2.changeTab,
    _ref2$baseClass = _ref2.baseClass,
    baseClass = _ref2$baseClass === void 0 ? css.tabLabel : _ref2$baseClass,
    _ref2$baseStyles = _ref2.baseStyles,
    baseStyles = _ref2$baseStyles === void 0 ? {} : _ref2$baseStyles,
    _ref2$activeClass = _ref2.activeClass,
    activeClass = _ref2$activeClass === void 0 ? css.activeLabel : _ref2$activeClass,
    _ref2$activeStyles = _ref2.activeStyles,
    activeStyles = _ref2$activeStyles === void 0 ? {} : _ref2$activeStyles,
    _ref2$disabledClass = _ref2.disabledClass,
    disabledClass = _ref2$disabledClass === void 0 ? css.disabledLabel : _ref2$disabledClass,
    _ref2$disabledStyles = _ref2.disabledStyles,
    disabledStyles = _ref2$disabledStyles === void 0 ? {} : _ref2$disabledStyles,
    _ref2$progressAnimati = _ref2.progressAnimation,
    progressAnimation = _ref2$progressAnimati === void 0 ? false : _ref2$progressAnimati;
  var isActive = activeTab === tabID;
  var buttonTheme = disabled ? disabledStyles : isActive ? activeStyles : baseStyles;
  var tabCls = "".concat(baseClass, " ").concat(disabled ? "".concat(disabledClass, " disabled-label") : isActive ? "".concat(activeClass, " active-label") : '');
  var tabTitle = children || /*#__PURE__*/React.createElement(TabTitle, {
    title: title,
    subTitle: subTitle,
    progressAnimation: progressAnimation
  });
  return /*#__PURE__*/React.createElement("button", {
    className: tabCls,
    style: buttonTheme,
    "data-tab-name": tabID,
    onClick: handleTabClick.bind(null, {
      disabled: disabled,
      changeTab: changeTab,
      tabID: tabID
    })
  }, tabTitle);
};
export default TabLabel;